module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-height": "40px",
      "min-width": "240px"
    }
  }, [_c('div', {
    staticClass: "ui right floated pagination menu"
  }, [_c('a', {
    class: (_vm.disabledFirstPage ? 'disabled ' : '') + 'icon item',
    on: {
      "click": function($event) {
        return _vm.backToOne()
      }
    }
  }, [_c('i', {
    staticClass: "angle double left icon"
  })]), _vm._v(" "), _c('a', {
    class: (_vm.disabledPreviousPage ? 'disabled ' : '') + 'icon item',
    on: {
      "click": function($event) {
        return _vm.backToPrevious()
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.currentPage + 1) + " / " + _vm._s(_vm.maxPage + 1))]), _vm._v(" "), _c('a', {
    class: (_vm.disabledNextPage ? 'disabled ' : '') + 'icon item',
    on: {
      "click": function($event) {
        return _vm.forwardToNext()
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })]), _vm._v(" "), _c('a', {
    class: (_vm.disabledLastPage ? 'disabled ' : '') + 'icon item',
    on: {
      "click": function($event) {
        return _vm.forwardToLast()
      }
    }
  }, [_c('i', {
    staticClass: "angle double right icon"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-073b44d3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/productsettings/ProductSettingsPage.Pagination.vue
// module id = 719
// module chunks = 2